import { useQuery } from '@tanstack/react-query';
import { getRelativeURLWithParams } from 'utils/url';
import { SEARCH_SUGGESTIONS } from 'constants/endpoints.api';
import { REQUEST_ID_HEADER } from 'constants/headers';
import { getRequestId } from 'utils/requestId';
import { SuggestionResponse } from './types';

export const useSearchSuggestionQuery = ({
  searchTerm,
  langId,
  storeIdentifier,
  storeId,
  catalogId,
  locale,
  serialNumber
}) =>
  useQuery<SuggestionResponse>({
    queryKey: [
      'suggestions',
      searchTerm,
      langId,
      storeIdentifier,
      storeId,
      catalogId,
      locale
    ],
    queryFn: async () => {
      const url = getRelativeURLWithParams(SEARCH_SUGGESTIONS, {
        q: searchTerm.toLowerCase(),
        langId,
        storeIdentifier,
        storeId,
        catalogId,
        locale,
        serialNumber
      });

      const res = await fetch(url, {
        headers: { [REQUEST_ID_HEADER]: getRequestId() }
      });

      return res.json();
    },

    // Query config
    enabled: searchTerm.length >= 3,
    placeholderData: (previousData) =>
      searchTerm.length >= 3 ? previousData : undefined
  });
